import React from "react";
import Chart from "react-apexcharts";

export default function AvailaibleClaim({ total, unlocked, claimed }) {
  const unlockedPercent =
    total > 0 ? Math.min(100, (unlocked / total) * 100) : 0;
  const claimedPercent = total > 0 ? Math.min(100, (claimed / total) * 100) : 0;

  const options = {
    chart: {
      height: 350,
      type: "radialBar",
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        track: {
          background: "#13313B",
        },
        hollow: {
          size: "60%",
        },
        dataLabels: {
          show: false,
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        strokeLinecap: "round",
      },
    },
    stroke: {
      lineCap: "round",
    },
    labels: ["Available", "Claimed"],
    colors: ["var(--btn-green-bg)", "#50BAD2"],
  };

  const series = [unlockedPercent, claimedPercent];

  return (
    <div className="flex items-center justify-center">
      <Chart options={options} series={series} type="radialBar" height={350} />
    </div>
  );
}
